<template>
  <div class="add-pay-box">
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="uid"
        label="用户id"
        align="center"
        fixed
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="objID"
        label="小说id"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.objID }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="举报内容"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="imgs"
        label="图片"
        align="center"
        min-width="200"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.imgs || !scope.row.imgs.length">未知</span>
          <div
            v-else
            class="picturePreview"
          >
            <img-load
              style="width: 70px; height: 70px"
              :src="imgUrl + item"
              fit="fill"
              v-for="(item, i) in scope.row.imgs"
              :key="i"
            ></img-load>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="processedReceipt"
        label="回执信息"
        align="center"
        min-width="160"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.processedReceipt || "暂无回复！" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="processingStatus"
        label="处理状态"
        align="center"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <p
            class="stuate"
            :style="
              (colors =
                scope.row.processingStatus === 0
                  ? 'background:#fff'
                  : scope.row.processingStatus === 1
                  ? 'background:rgba(29,211,66,1)'
                  : 'background:rgba(255,100,97,1)')
            "
          >
            {{ scope.row.processingStatus | processingStatusList }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="150"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="toExamine('pass', scope.row)"
            :disabled="scope.row.processingStatus === 0 ? false : true"
            >处理</el-button
          >
          <el-button
            type="info"
            size="mini"
            @click="toExamine('refuse', scope.row)"
            :disabled="scope.row.processingStatus === 0 ? false : true"
            >忽略</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 添加审核检查 ,即修改报错详情弹框 -->
    <check ref="check" @handlerAgentList="getErrFeedback" />
    <!-- 背景图集预览窗口 -->
    <preview-picture
      ref="previewPicture"
      @handlerChannelList="getErrFeedback"
    ></preview-picture>
  </div>
</template>
<script>
import Check from "./components/check";
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import PreviewPicture from "./components/previewPicture";
export default {
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      type: "",
      tableData: [],
      total: "",
      processingStatusList: [
        { label: "全部", value: undefined },
        { label: "等待处理", value: 0 },
        { label: "处理完成", value: 1 },
        { label: "忽略", value: 2 },
      ],
      feedbackTypes: [
        { label: "无效联系方式", value: 1 },
        { label: "骗子", value: 2 },
        { label: "重复信息", value: 3 },
      ],
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getErrFeedback();
  },
  components: {
    Check,
    PreviewPicture,
  },
  methods: {
    // 请求小说报错信息
    getErrFeedback() {
      this.loading = true;
      API.getErrFeedback({
        pageNumber: this.params.pageNumber,
        pageSize: this.params.pageSize,
      })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 审核
    toExamine(type, data) {
      this.$refs.check.open(type, data);
    },
    //修改报错详情
    editAction(data) {
      this.$refs.edit.open(data);
    },
    //  图集预览
    previewPicture(pictureArr, id) {
      const Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id);
    },
    // 打开详情弹窗
    open(data) {
      this.getErrFeedback();
      this.params_detail = data;
      window.console.log(data, "000");
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getErrFeedback();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getErrFeedback();
    },
  },
};
</script>

<style lang="scss" scoped>
.add-pay-box {
  .el-date-picker,
  .el-input {
    width: 150px;
  }
  .form_item {
    margin-top: 10px;
  }
  .protocol {
    font-size: 10px;
    margin-left: 10px;
    color: green;
  }
}
</style>
